import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { BsDot } from "react-icons/bs";
import Isocompliance from "../assets/svg/Iso_logo.svg";
import { AiOutlineMenu, AiOutlineClose } from "react-icons/ai";
import { BsFileEarmarkText } from "react-icons/bs";
import { RiPresentationFill } from "react-icons/ri";
import { FaUserPlus } from "react-icons/fa";
import { TbClipboardList } from "react-icons/tb";
import { HiOutlineDocumentText } from "react-icons/hi";
import { BiSolidDashboard } from "react-icons/bi";
import { TbLogout2 } from "react-icons/tb";
import { IoNotificationsOutline } from "react-icons/io5";
import axiosInstanceAuth from "../../apiInstances/axiosInstanceAuth";
import useEncryption from "../useEncryption/useEncryption";
import { AiFillDelete } from "react-icons/ai";
import { io } from "socket.io-client";
import Contact from "../assets/svg/contact.svg";
import Terms from "../assets/svg/terms.svg";

// import Avtar from "../assets/img/about.jpg";
import Avtar from "../assets/img/Ellipse.png";
import { BACKEND_BASE_URL } from "../../apiInstances/baseurl";

const Sidebar = ({ value }) => {
  const getpath = useLocation().pathname.split("/")?.[1];
  // //console.log(getpath);
  const { decryptData } = useEncryption();
  const navigate = useNavigate();
  const [selectedItem, setSelectedItem] = useState(null);
  const [open, setOpen] = useState();
  const [menu, setMenu] = useState(false);
  const userRole = localStorage.getItem("Role");
  const isAdmin = userRole === "admin";
  //const [selectedSideName, setSelectedSideName] = useState(); // Add this state

  const [userProfile, setUserProfile] = useState({});
  const [adminProfile, setAdminProfile] = useState({});
  const [count, setCount] = useState("");
  const [showMenu, setShowMenu] = useState(false);
  const [socket, setSocket] = useState(null); //socket
  const userId = localStorage.getItem("Token");

  const ConfirmLogOut = () => {
    localStorage.clear();
    navigate("/signin");
  };

  const getAdminProfile = async () => {
    await axiosInstanceAuth
      .get("/admin_profile")
      .then((res) => {
        const myData = decryptData(res?.data?.data);
        setAdminProfile(myData?.data || []);
        //console.log("🚀 ~ .then ~ myData:", myData);
      })
      .catch((err) => {
        //console.log("err --->", err);
      });
  };
  const getUserProfile = async () => {
    await axiosInstanceAuth
      .get("/user_profile")

      .then((res) => {
        const myData = decryptData(res?.data?.data);
        setUserProfile(myData?.data || []);
        //console.log("Userrrrrrrrrrrrrr ProfileData---->", myData?.data);
      })
      .catch((err) => {
        //console.log("err --->", err);
      });
  };

  useEffect(() => {
    if (userRole === "admin") {
      getAdminProfile();
    } else {
      getUserProfile();
    }
  }, []);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const handleCloseMenu = () => {
    setShowMenu(!showMenu);
  };
  const sidebarStyle = {
    maxHeight: "calc(100vh - 48px)", // Adjust the height as needed
    overflowY: "auto",
  };

  const handleSideNameClick = (e, d) => {
    {
      //console.log("d-->", e);
    }
    //setSelectedSideName(e);
    navigate(`/${d}`);
    setOpen(e);

    setMenu(!menu);
    if (d === "notification") {
      {
        //console.log("-------------------------------");
      }
      countall1();
    }
  };

  const navbarData = [
    {
      id: 0,
      to: "",
      sideName: "Templates",
      coloricon: <BsFileEarmarkText size={25} />,
    },
    {
      id: 1,
      to: "visual",
      sideName: "Visual Presentation ",
      coloricon: <RiPresentationFill size={25} />,
    },
    {
      id: 2,
      to: "addUser",
      sideName: "Add User",
      coloricon: <FaUserPlus size={25} />,
    },
    {
      id: 3,
      to: "dashboard",
      sideName: "Dashboard",
      coloricon: <BiSolidDashboard size={25} />,
    },
    {
      id: 5,
      to: "todolist",
      sideName: "To-Do-List",
      coloricon: <TbClipboardList size={25} />,
    },
    // {
    //   id: 6,
    //   to: "download",
    //   sideName: "Document",
    //   coloricon: <HiOutlineDocumentText size={25} />,
    //   component: [
    //     {
    //       id: 1,
    //       pathname: "download",
    //       submenu: "Download",
    //     },
    //     {
    //       id: 2,
    //       pathname: "uplode",
    //       submenu: "Upload",
    //     },
    //     {
    //       id: 3,
    //       pathname: "#",
    //       submenu: "Master Copy",
    //     },
    //   ],
    // },
    {
      id: 8,
      to: "notification",
      sideName: "Notification",
      coloricon: <IoNotificationsOutline size={25} />,
      count: `${count}`,
    },
  ];

  const countall = async () => {
    await axiosInstanceAuth
      .get(`/notify_count`)
      .then((res) => {
        // //console.log("res", res);
        const myData = decryptData(res?.data.data);
        const data = myData?.data.count;
        setCount(data);
        //console.log("countmyData --->?", data);
      })
      .catch((err) => {
        //console.log("err --->", err);
      });
  };

  const countall1 = async () => {
    await axiosInstanceAuth
      .get(`/seen_notify`)
      .then((res) => {
        // //console.log("res", res);
        const myData = decryptData(res?.data?.data);
        //console.log("countmyData11 --->", myData);
      })
      .catch((err) => {
        //console.log("err --->", err);
      });
  };

  useEffect(() => {
    countall();
  }, []);

  const [showModal, setShowModal] = React.useState(false);

  const modelShows = () => {
    setShowModal(true);
  };

  const countBackgroundColor = "bg-black hover:bg-white";
  const countTextColor = "text-white hover:text-black";
  useEffect(() => {
    const socket = io(BACKEND_BASE_URL);
    socket.emit("join", {
      userid: userId,
    });
    //console.log("====================================> messagrrrrrrr");
    //Handle incoming notifications
    socket.on("show_count", (count) => {
      //console.log("Received notification count:", count);
      setCount(count);
    });
    return () => {
      socket.disconnect();
      //console.log("Socket disconnected on component unmount");
    };
  }, []);
  return (
    <>
      <div className="">
        <button
          className={
            !showMenu &&
            `fixed block lg:hidden top-8 left-2 hover:text-white focus:outline-none bg-[#294894] rounded-full p-2 text-white`
          }
          onClick={toggleMenu}
        >
          <AiOutlineMenu size={24} />
        </button>

        {showModal ? (
          <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
              <div className="relative w-auto my-6 mx-auto max-w-3xl">
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  <div className="relative p-6 flex-auto">
                    <span className="justify-center items-center flex">
                      <AiFillDelete className="w-16 h-16 fill-red-500" />
                    </span>
                    <p className="my-4 text-center leading-relaxed text-2xl text-red-500">
                      Logout
                    </p>
                    <p className="my-4 text-slate-500 text-lg leading-relaxed">
                      Are You Sure You want to Logout ?
                    </p>
                  </div>

                  <div className="flex gap-2 items-center justify-end p-3 border-t border-solid border-slate-200 rounded-b">
                    <button
                      onClick={() => setShowModal(false)}
                      class="text-red-500   font-bold py-2 px-6 rounded"
                    >
                      No
                    </button>
                    <button
                      onClick={ConfirmLogOut}
                      class="bg-emerald-500 active:bg-emerald-600 px-6 py-2  text-white font-bold  rounded"
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        ) : null}

        <div
          className={
            !showMenu
              ? `h-[100%] fixed top-0 bg-[#22345C] lg:block hidden `
              : "h-[100%] fixed top-0 bg-[#22345C] block lg:hidden  "
          }
        >
          <div className="overflow-hidden w-64 relative">
            <div className="grid place-items-center p-6 cursor-pointer  w-full">
              <img src={Isocompliance} alt="Logo" />
            </div>
          </div>

          <div className="">
            <div
              style={sidebarStyle}
              className="  touch-auto  space-y-1 cursor-pointer"
            >
              <div className="text-white mb-5  cursor-pointer ">
                {navbarData.map((e, index) => (
                  <>
                    {isAdmin || e.to !== "addUser" ? (
                      <div
                        key={index}
                        className={`flex cursor-pointer rounded-md m-2 ${
                          getpath === e.to
                            ? "bg-white text-black "
                            : "hover:bg-white hover:text-black "
                        }`}
                      >
                        <div
                          className="flex items-center gap-3 py-3 px-5 text-xl "
                          onClick={() => handleSideNameClick(e.id, e.to)}
                        >
                          {e?.coloricon}
                          <h1 className="text-base">{e?.sideName}</h1>
                          {/* <p className=" text-base">{e?.count}</p> */}
                          {e.to === "notification" && (
                            <div
                              className={`${
                                getpath === e.to
                                  ? "bg-red-500 text-white"
                                  : "bg-red-500 text-white"
                              } rounded-full w-6 h-6 flex items-center justify-center text-xs font-semibold hover:bg-red-500 hover:text-white`}
                            >
                              {e?.count}
                            </div>
                          )}
                        </div>
                      </div>
                    ) : null}
                  </>
                ))}
              </div>

              <hr className="mt-6" />

              <div className="mx-4 m-2 mt-5 px-3 space-y-3">
                <Link
                  to="/setting"
                  className="flex items-center gap-4 pt-3 text-white   "
                >
                  <img src={Terms} alt="" className="h-6" />
                  <p className="text-[18px] ">Terms And Policy</p>
                </Link>
                <Link className="flex items-center gap-4 pt-3 text-white   ">
                  <img src={Contact} alt="" className="h-6" />
                  <p className="text-[18px]">Contact Us</p>
                </Link>
                <div
                  onClick={modelShows}
                  className="flex items-center gap-4 pt-3 text-white   "
                >
                  <TbLogout2 size={25} />
                  <p className="text-[18px]">Log Out</p>
                </div>
              </div>
              <div>
                <Link to="/profile">
                  <div class="flex absolute items-center w-full py-1.5 font-medium  whitespace-nowrap bg-[#3A4B6D] bottom-0">
                    <img
                      class="w-14 h-14 rounded-full ml-12"
                      // src={Isocompliance}
                      src={`${BACKEND_BASE_URL}${
                        userRole === "admin"
                          ? adminProfile?.logo
                          : userProfile?.logo
                      }`}
                      alt="logo"
                    />
                    <div class="pl-3">
                      <div class="text-xl font-semibold text-white">
                        {userRole === "admin"
                          ? adminProfile.name
                          : userProfile.name}
                      </div>
                      {/* <div class="font-normal text-xs text-[#B0B0B0]">
                        Director
                      </div> */}
                      <div class="font-normal text-base text-[#B0B0B0]">
                        {userRole === "admin"
                          ? adminProfile.role
                          : userProfile.role}
                      </div>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>

          <button
            className={
              "absolute  lg:hidden top-2 left-[275px] hover:text-white focus:outline-none  rounded-full p-2 text-white"
            }
            onClick={handleCloseMenu}
          >
            <AiOutlineClose size={24} />
          </button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
